module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"#8b8b8b\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <polygon points=\"4.5 3 4.5 21 19.5 12 4.5 3\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/video.svg
// module id = 818
// module chunks = 1